import { memo } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { BzModal, BzModalBody } from '../../../components';
import { useDispatch, useSelector } from 'react-redux';
import { handleModal } from '../../../redux/actions/modals';

const ManageColumnStatusModal = ({ msgContent, ...props }) => {


    const { modals } = useSelector(state => state.modals);
    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(handleModal([{ 'MANAGE_COLUMNS_MODAL_STATUS': false }]));
    };

    return (
        <BzModal show={modals['MANAGE_COLUMNS_MODAL_STATUS']} onHide={handleClose}>
            <BzModalBody>
                <Container fluid className='p-0'>

                    <Row className='g-0 py-3'>
                        <Col className='text-center'>
                            <div className='icon-64 icon-done icon-positive'></div>
                        </Col>
                    </Row>
                    <Row className='g-0 pt-3'>
                        <Col className='text-center font-medium font-size4 color-text'>
                            {/* Ameersha N: 06-11-2023 : BT-96552 : Manage Columns – Issue - 'and' is missing – Start*/}
                            <span>"{msgContent}" Profile saved and applied successfully</span>
                            {/* Ameersha N: 06-11-2023 : BT-96552 : Manage Columns – Issue - 'and' is missing – End*/}
                        </Col>
                    </Row>
                </Container>
            </BzModalBody>


        </BzModal>
    );
};

export default memo(ManageColumnStatusModal);